import { useState } from 'react'
import { Linking } from 'react-native'

import { BottomSheet, Stack, XStack } from '@zet/design-system'
import { Button } from '@zet/design-system/button'
import { Icon } from '@zet/design-system/icons'
import Pressable from '@zet/design-system/pressable'
import { B2, BTN, SH1, SH2 } from '@zet/design-system/typography'
import { useUserContext } from '@zet/feature-user'
import { i18n } from '@zet/localization'
import EnglishLanguage from '@zet/svg/englishLanguage'
import HindiLanguage from '@zet/svg/hindiLanguage'

interface ShareArnProps {
  phone: string
  brandComms: object
  isBottomSheetVisible: boolean
  setIsBottomSheetVisible: (value: boolean) => void
  customerName: string
  item: object
  askCode: string
}

const ShareWhatsAppMessageForArn: React.FC<ShareArnProps> = ({
  phone,
  brandComms,
  isBottomSheetVisible,
  setIsBottomSheetVisible,
  customerName,
  item,
  askCode,
}) => {
  const [defaultLanguage, setDefaultLanguage] = useState(i18n.locale)
  const arnShareMessage = brandComms?.ARN?.shareContentARN?.[defaultLanguage]
  const { data: user } = useUserContext()

  return (
    <BottomSheet
      visible={isBottomSheetVisible}
      disableBottomSheet={() => setIsBottomSheetVisible(false)}
      onDismiss={() => setIsBottomSheetVisible(false)}
      sheetName="arn_whatsapp_message"
    >
      <>
        <XStack className="border-grays-40 mt-2 items-center justify-between border-b">
          <XStack className="mx-3">
            <Icon type="Share" size={24} />
            <SH1 className="ml-4/2">{i18n.t('hdfcArn.getArnNumber')}</SH1>
          </XStack>
          <Pressable
            onPress={() => setIsBottomSheetVisible(false)}
            className="mr-3"
          >
            <Icon type="Close" />
          </Pressable>
        </XStack>
        <B2 className="text-grays-60 mx-3 my-3">
          {i18n.t('hdfcArn.messageHeading')}
        </B2>
        <Stack className="my-4/2 bg-decorative-malachiteGreen mx-3 p-3">
          <SH2 className="mb-1">
            {i18n.t('hdfcArn.namaste', { customer: customerName })}
          </SH2>
          <B2>{arnShareMessage ?? ''}</B2>
        </Stack>
        <Stack className="mx-3 my-3 ">
          <B2>{i18n.t('shareCardLink.languageSelection')}</B2>
          <XStack className="mt-3">
            <Pressable
              className={`w-[40%] rounded-xl border p-2 ${
                defaultLanguage === 'en'
                  ? 'border-primary-100'
                  : 'border-grays-30'
              }`}
              onPress={() => setDefaultLanguage('en')}
            >
              <XStack className="items-center justify-center">
                <EnglishLanguage />
                <B2 className="text-grays-60 ml-2">
                  {i18n.t('shareCardLink.english')}
                </B2>
              </XStack>
            </Pressable>
            <Pressable
              className={`ml-3 w-[40%] rounded-xl border p-2 ${
                defaultLanguage === 'hi'
                  ? 'border-primary-100'
                  : 'border-grays-30'
              }`}
              onPress={() => setDefaultLanguage('hi')}
            >
              <XStack className="items-center justify-center align-middle">
                <HindiLanguage />
                <B2 className="text-grays-60 ml-2">
                  {i18n.t('shareCardLink.hindi')}
                </B2>
              </XStack>
            </Pressable>
          </XStack>
        </Stack>
        <Stack className="px-4/2 items-center py-3">
          <Button
            fullWidth
            size={'md'}
            className={'bg-primary-100 justify-center px-3 py-2'}
            onPress={() => {
              Linking.openURL(
                `whatsapp://send?phone=${phone}&text=${arnShareMessage}`
              )
              setIsBottomSheetVisible(false)
            }}
            eventName="click_action"
            eventPayload={{
              item_name: 'lead_page_faq_whatsapp_share',
              page_name: askCode,
              partner_id: item?.partnerId,
              brand_name: brandComms.name,
              lead_id: item?.id,
              user_id: user.id,
              customer_id: item?.customerId,
              arn: item?.referenceId,
            }}
          >
            <BTN className="text-neutral-white100 text-center">
              {i18n.t('hdfcArn.sendMessage', { customer: customerName })}
            </BTN>
          </Button>
        </Stack>
      </>
    </BottomSheet>
  )
}

export default ShareWhatsAppMessageForArn
